import React from 'react';
import styled from 'styled-components';
import WorkPreviewCard from '../components/Cards';
import { HalfBanner } from '../components/Banners';
import { media, TransitionMixin } from '../components/helpers';

const WorkSection = styled.section`
	background: #fff;
	padding: 0px 0px;
	.title-wrap {
		padding: 0px 40px;
		text-align: center;
		h2 {
			color: #000;
			font-family: 'Open Sans', sans-serif;
			margin-top: 0px;
			margin-bottom: 40px;
			font-weight: 300;
		}
	}

	.work-preview-grid {
		display: grid;
		grid-gap: 40px;
		max-width: 95vw;
		margin: 0 auto;
		padding: 40px 0px;

		${media.small`grid-template-columns: repeat(2, 1fr);`};
		${media.large`grid-template-columns: repeat(3, 1fr);`};
	}
	a {
		text-decoration: none;
		color: #222;

		&:hover {
			.lightbox-wrap {
				-webkit-box-shadow: 0 24px 38px 3px rgba(0, 0, 0, 0.14),
					0 9px 46px 8px rgba(0, 0, 0, 0.12),
					0 11px 15px -7px rgba(0, 0, 0, 0.2);
				box-shadow: 0 24px 38px 3px rgba(0, 0, 0, 0.14),
					0 9px 46px 8px rgba(0, 0, 0, 0.12),
					0 11px 15px -7px rgba(0, 0, 0, 0.2);
			}

			.links {
				a {
					background: #333;
					color: #fff !important;
				}
			}
		}

		.lightbox-wrap {
			border: 1px solid #d8d3d3;
			${TransitionMixin('.25s')};

			.lightbox-body {
				background: #fff;
				display: grid;
				grid-template-columns: 50% 50%;
				padding: 20px;

				h3 {
					font-family: 'Open Sans', sans-serif;
					margin: 0px;

					font-weight: 300;
				}

				.links {
					align-self: center;
					text-align: right;
					ul {
						margin: 0px;
						padding: 0px;
						list-style: none;
						li {
							a {
								color: #333;
								text-decoration: none;
								border: 1px solid #333;
								padding: 5px 20px;
								font-size: 12px;
								text-transform: uppercase;
								${TransitionMixin('.25s')};
								&:hover {
									background: #333;
									color: #fff;
								}
							}
						}
					}
				}
			}
		}
	}
`;

export default class WorkPage extends React.Component {
	render() {
		const { data } = this.props;
		return (
			<WorkSection>
				<HalfBanner title="Our Work" image={data.topBanner} mobile={true} />
				<div className="work-preview-grid">
					{data.allWordpressWpPortfolio.edges.map(portfolio => {
						return <WorkPreviewCard key={portfolio.id} portfolio={portfolio} />;
					})}
				</div>
			</WorkSection>
		);
	}
}

export const query = graphql`
	query WorkData {
		topBanner: imageSharp(id: { regex: "/work.jpeg/" }) {
			sizes(quality: 100, maxWidth: 2300) {
				...GatsbyImageSharpSizes
			}
		}
		mobileTopBanner: imageSharp(id: { regex: "/mhome.jpeg/" }) {
			sizes(quality: 100, maxWidth: 1200) {
				...GatsbyImageSharpSizes
			}
		}
		allWordpressWpPortfolio(sort: { fields: [date], order: DESC }) {
			edges {
				node {
					id
					title
					slug
					acf {
						site_url
						client
						date_completed
						tags
					}
					featured_media {
						localFile {
							childImageSharp {
								sizes(quality: 100, maxWidth: 800) {
									...GatsbyImageSharpSizes
								}
							}
						}
					}
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/pages/work.js